import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SharedTrcContent from '../../../shared/trcSummary/trcContent/TrcContent';
import Spinner from '../../../../../components/spinner/Spinner';
import { getTrcResultsWithoutDetails } from '../../../../../utils/shared/trcUtils';
import { TITLE } from '../../../../../constants/shared/CommonConstants';

const TrcContent = ({
    studentId,
    studentResults,
    fetchTrcItemLevelDetails,
    selectedGradeYear,
    isDetailsReadyForRendering,
    areResultsUpdating,
    openProbeDetails,
    trcSummaryData,
    cards,
    summeryLabel,
}) => {
    useEffect(() => {
        const fetchItemLevelDetails = async results =>
            fetchTrcItemLevelDetails(getTrcResultsWithoutDetails(results));

        if (!isDetailsReadyForRendering) {
            fetchItemLevelDetails(studentResults);
        }
    }, []);

    return isDetailsReadyForRendering && !areResultsUpdating ? (
        <SharedTrcContent
            studentId={studentId}
            selectedGradeYear={selectedGradeYear}
            openProbeDetails={openProbeDetails}
            trcSummaryData={trcSummaryData}
            cards={cards}
            summeryLabel={summeryLabel}
        />
    ) : (
        <Spinner />
    );
};

TrcContent.defaultProps = {
    studentResults: [],
    trcSummaryData: [],
    studentId: '',
    cards: [],
    selectedGradeYear: {},
    isDetailsReadyForRendering: false,
    areResultsUpdating: false,
    fetchTrcItemLevelDetails: () => {},
    summeryLabel: TITLE.SUMMER_TITLE,
};

TrcContent.propTypes = {
    studentResults: PropTypes.arrayOf(PropTypes.object),
    trcSummaryData: PropTypes.arrayOf(PropTypes.object),
    studentId: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.element),
    selectedGradeYear: PropTypes.object,
    openProbeDetails: PropTypes.func.isRequired,
    isDetailsReadyForRendering: PropTypes.bool,
    areResultsUpdating: PropTypes.bool,
    fetchTrcItemLevelDetails: PropTypes.func,
    summeryLabel: PropTypes.string,
};

export default TrcContent;
